export default function cleanCognitoLocalStorage(
  keyPrefix = 'CognitoIdentityServiceProvider',
  userPoolWebClientID = process.env.REACT_APP_AMAZON_USER_POOL_WEB_CLIENT_ID,
) {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith(`${keyPrefix}.${userPoolWebClientID}`))
      localStorage.removeItem(key);
  });
}
